<template>
	<div>
		<div
			class="modal fade modal-fullscreen-mobile"
			ref="modal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
		>
			<div class="modal-dialog vld-parent" role="document">
				<div class="modal-content">
					<div class="modal-header modal-header-banner">
						<button
							v-if="!required"
							class="button button-transparent button-modal-back"
							@click="close(false)"
						>
							<i class="sk-icon-times"></i>
						</button>
						<div>
							<h1>Join Your 2ndKitchen Community!</h1>
						</div>
						<div class="header-description">
							{{ description }}
						</div>
						<div class="header-perks">
							<div class="header-perk">
								<img
									src="/images/2k-menu.png"
									alt="Header Perk 1"
								/>
								<div>Unique Local Dining Options</div>
							</div>
							<div class="header-perk">
								<img
									src="/images/2k-delivery.png"
									alt="Header Perk 2"
								/>
								<div>Unlimited Free Delivery</div>
							</div>
							<div class="header-perk">
								<img
									src="/images/2k-coupon.png"
									alt="Header Perk 3"
								/>
								<div>Special Rewards & Discounts</div>
							</div>
						</div>
					</div>
					<div class="modal-body">
						<loading :active="loading" />
						<div class="modal-inner-content">
							<div class="phone-input">
								<SkInput
									:ref="'phoneInput'"
									:name="'Phone Number'"
									:type="'tel'"
									:placeholder="'(555) 555-5555'"
									:required="true"
									:validation="phoneRegex"
									:autoFocus="isMobile"
									v-model="phone"
								/>
								<div class="phone-disclaimer">
									Your phone number is your login - it’s also
									how we alert you when your food is ready.
								</div>
							</div>
							<button
								class="button button-primary"
								@click="phoneSignup"
							>
								Join with Phone Number
							</button>
							<div class="sk-divider-wrapper">
								<div class="divider"></div>
								<span class="divider-text">or</span>
								<div class="divider"></div>
							</div>
							<div class="social-login-wrapper">
								<button
									class="button social-btn"
									@click="googleSignup"
								>
									<i class="sk-icon-google-brand"></i>
									Google
								</button>
								<button
									class="button social-btn"
									@click="facebookSignup"
								>
									<i class="sk-icon-facebook-brand"></i>
									Facebook
								</button>
							</div>
							<button class="button button-text" @click="signIn">
								Already a member?
								<b>Sign In</b>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-body {
	justify-content: flex-start;
	background: var(--sk-grey-bg);
}

.modal-header {
	flex-direction: column;
}

.modal-header-banner {
	height: 100%;
	min-height: 170px;
	max-height: 340px;
	padding: 20px;
	align-items: flex-start;
}

.modal-header-banner > div {
	max-width: 335px;
	width: 100%;
	margin: 0 auto;
}

.modal-header-banner h1,
.modal-header-banner .header-description,
.header-perk > div {
	color: var(--gR-white);
}

.modal-header-banner h1 {
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 12px;
}

.modal-header-banner .header-description {
	font-size: 12px;
	margin-bottom: 25px;
}

.header-perks {
	height: 100%;
	display: flex;
	flex-direction: column;
}

.header-perk {
	font-size: 12px;
	font-weight: 600;
	height: 80px;
	display: flex;
	align-items: center;
	height: 100%;
	max-height: 80px;
	min-height: 50px;
}

.header-perk img {
	height: 40px;
	width: 40px;
	margin: 0 10px 0 0;
}

.modal-inner-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
	max-width: 335px !important;
	min-width: 280px !important;
	width: 100% !important;
}

.phone-input {
	max-height: 170px;
	min-height: 90px;
	flex-shrink: 1;
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
}

.phone-input >>> .sk-input-wrapper {
	min-height: 50px;
}

.phone-input >>> .sk-input-wrapper,
.modal-inner-content .button:not(.social-btn) {
	width: 100% !important;
	max-width: 100% !important;
	margin: 0 !important;
}

.phone-disclaimer {
	font-size: 9px;
	color: var(--sk-grey3);
	margin-top: 10px;
	margin-left: 15px;
	margin-bottom: 5px;
}

.modal-inner-content .button {
	flex-shrink: 0;
}

.social-login-wrapper {
	width: 100%;
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
	flex-shrink: 0;
}

@media only screen and (min-width: 700px) {
	.phone-input {
		height: 170px;
	}

	.phone-disclaimer {
		font-size: 12px;
	}
}

@media only screen and (max-height: 600px) {
	.modal-header-banner h1 {
		font-size: 16px;
	}

	.modal-header-banner .header-description {
		margin-bottom: 10px;
	}

	.modal-header {
		padding-bottom: 0;
	}

	.header-perks {
		flex-direction: row;
		align-items: center;
	}

	.header-perk {
		flex-direction: column;
		margin-right: 10px;
		text-align: center;
		font-size: 10px;
	}

	.header-perk img {
		margin-right: 0;
	}

	.sk-divider-wrapper {
		margin: 10px 0;
	}

	.social-login-wrapper {
		margin-bottom: 0;
	}
}

@media only screen and (max-height: 475px) {
	.modal-header {
		flex: 0;
	}
}
</style>

<script>
import utils from "@/utils"
import facebook from "@/services/facebook"
import google from "@/services/google"
import mobileResponsivenessMixin from "@/mixins/mobile-responsiveness-mixin"
import SkInput from "@/components/common/SkInput.vue"
import Loading from "vue-loading-overlay"

export default {
	name: "SignupModal",
	mixins: [mobileResponsivenessMixin],
	components: {
		SkInput,
		Loading
	},
	data: function () {
		return {
			phoneRegex: /^[0-9]{10,15}$/,
			phone: "",
			required: false,
			isOpen: false,
			loading: false
		}
	},
	computed: {
		businessName() {
			return this.$store.state.business && this.$store.state.business.name
				? this.$store.state.business.name
				: ""
		},
		description() {
			return `Enjoy exclusive access to excellent food, rewards, and events as a resident of ${this.businessName}.`
		}
	},
	methods: {
		open(options) {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Signup Modal Opened"
			})
			this.isOpen = true
			this.loading = false
			if (options && options.required) {
				$(this.$refs.modal).modal({
					backdrop: "static",
					keyboard: false
				})
				this.required = true
			} else {
				$(this.$refs.modal).modal("show")
				this.required = false
			}
		},
		async googleSignup() {
			try {
				this.loading = true
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Google Signin Clicked"
				})
				const authResponse = await google.authenticate()
				if (
					authResponse &&
					authResponse.error == "popup_closed_by_user"
				) {
					this.$store.dispatch("sendMixpanelEvent", {
						msg: "Google Signin Closed"
					})
				} else if (authResponse) {
					const promise = utils.createPromise()
					this.$emit("authenticateGoogle", {
						response: authResponse,
						resolve: promise.resolve
					})
					const authenticated = await promise.promise
					if (authenticated) {
						this.close({
							provider: "GOOGLE"
						})
					}
				}
				this.loading = false
			} catch (e) {
				this.loading = false
				throw e
			}
		},
		async facebookSignup() {
			try {
				this.loading = true
				const authResponse = await facebook.authenticate()
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Facebook Signin Clicked"
				})
				if (authResponse) {
					const promise = utils.createPromise()
					this.$emit("authenticateFacebook", {
						response: authResponse,
						resolve: promise.resolve
					})
					const authenticated = await promise.promise
					if (authenticated) {
						this.close({
							provider: "FACEBOOK"
						})
					}
				}
				this.loading = false
			} catch (e) {
				this.loading = false
				throw e
			}
		},
		async phoneSignup() {
			try {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Phone Number Entered",
					data: {
						phone: this.phone
					}
				})
				const validPhoneNumber = this.$refs.phoneInput.validate()
				if (!validPhoneNumber) {
					this.$store.dispatch("sendMixpanelEvent", {
						msg: "Phone Number Invalid",
						data: {
							phone: this.phone
						}
					})
					return
				}
				this.loading = true
				const promise = utils.createPromise()
				this.$emit("authenticatePhone", {
					phone: this.phone,
					resolve: promise.resolve
				})
				let authenticatedPhone = await promise.promise
				if (!authenticatedPhone) {
					this.loading = false
					return
				}
				if (!this.$store.state.user.isVerified) {
					const promise = utils.createPromise()
					this.$emit("sendSMS", {
						phone: this.phone,
						resolve: promise.resolve
					})
					const sentSMS = await promise.promise
					if (!sentSMS) {
						this.loading = false
						return
					}
				}
				this.close({
					provider: "PHONE",
					phone: this.phone
				})
				this.loading = false
			} catch (e) {
				this.loading = false
				throw e
			}
		},
		signIn() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Sign In Clicked"
			})
			this.close({
				nextStep: "LOGIN"
			})
		},
		close(result) {
			this.emitResult(result)
			$(this.$refs.modal).modal("hide")
		},
		emitResult(result) {
			if (this.isOpen) {
				this.$emit("onResult", result)
				this.isOpen = false
			}
		}
	},
	mounted: function () {
		$(this.$refs.modal).on("hidden.bs.modal", () => {
			this.emitResult(false)
		})
	}
}
</script>
